import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconCardLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.204 2.51A2 2 0 0 1 19 4.5v15l-.01.204a2 2 0 0 1-1.786 1.785L17 21.5H7l-.204-.01a2 2 0 0 1-1.785-1.786L5 19.5v-15a2 2 0 0 1 1.796-1.99L7 2.5h10l.204.01ZM7 4a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-15A.5.5 0 0 0 17 4H7Zm6.5 2.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h2Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconCardLine;
